import { Injectable } from '@angular/core'

import { Task, TaskType } from './task.model'
import { environment } from '../../../environments/environment'

import * as firebase from 'firebase'

@Injectable()
export class TaskService {

  private readonly firebaseRef = firebase.database().ref(environment.firebaseRoot)

  constructor() { }

  public startTask(task: Task) {
    this.firebaseRef.child('queue/tasks').push({
      type: TaskType.toString(task.type),
      sourceId: task.sourceUid,
      targetId: task.targetUid,
      chatID: task.chatId
    })
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/core/tasks/task.service.ts